// Şifre + canlı güç göstergesi + gereksinim kontrol listesi.
// §4.1.3 design ref: bar + etiket + 4 kural checkbox'ı.

import type { PasswordStrength } from "../../lib/password-strength";

interface Props {
  label?: string;
  value: string;
  onChange: (v: string) => void;
  disabled?: boolean;
  autoFocus?: boolean;
  strength?: PasswordStrength;
  showRules?: boolean;
  showStrength?: boolean;
  autoComplete?: string;
}

export function PasswordField({
  label = "Yeni Şifre",
  value,
  onChange,
  disabled,
  autoFocus,
  strength,
  showRules,
  showStrength,
  autoComplete = "new-password",
}: Props): JSX.Element {
  return (
    <div className="mb-5">
      <label className="block mb-1.5 text-sm font-medium" style={{ color: "var(--color-text)" }}>
        {label}
      </label>
      <input
        type="password"
        autoComplete={autoComplete}
        required
        autoFocus={autoFocus}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="w-full px-3 py-2.5 rounded-lg border"
        style={{
          background: "var(--color-surface)",
          borderColor: "var(--color-border)",
          color: "var(--color-text)",
          fontSize: "0.95rem",
        }}
        placeholder="••••••••••••"
      />
      {showStrength && strength && value.length > 0 ? (
        <div className="mt-2">
          <div
            className="rounded-full overflow-hidden"
            style={{ height: 4, background: "var(--color-border)" }}
          >
            <div
              className="h-full transition-all"
              style={{
                width: `${strength.barPercent}%`,
                background: strength.color,
                transition: "width 180ms ease, background 180ms ease",
              }}
            />
          </div>
          <div
            className="flex justify-between mt-1.5 text-xs"
            style={{ color: "var(--color-text-3)" }}
          >
            <span>
              Güç:{" "}
              <strong style={{ color: strength.color, fontWeight: 600 }}>{strength.label}</strong>
            </span>
            <span>İdeal: 12+ karakter</span>
          </div>
          {strength.feedback ? (
            <p className="mt-1 text-xs" style={{ color: "var(--color-text-3)" }}>
              💡 {strength.feedback}
            </p>
          ) : null}
        </div>
      ) : null}
      {showRules && strength ? (
        <div
          className="mt-3 px-3 py-2.5 rounded-lg text-xs"
          style={{ background: "rgba(15,42,61,0.04)", border: "1px solid var(--color-border)" }}
        >
          <div
            className="mb-2 font-semibold uppercase tracking-wide"
            style={{ color: "var(--color-text-2)", fontSize: "0.7rem" }}
          >
            Şifre Gereksinimleri
          </div>
          <div className="grid grid-cols-2 gap-1.5">
            <Rule ok={strength.rules.minLength} label="En az 12 karakter" />
            <Rule ok={strength.rules.hasUpper} label="Bir büyük harf" />
            <Rule ok={strength.rules.hasDigit} label="Bir rakam" />
            <Rule ok={strength.rules.hasSpecial} label="Bir özel karakter (öneri)" />
          </div>
        </div>
      ) : null}
    </div>
  );
}

function Rule({ ok, label }: { ok: boolean; label: string }): JSX.Element {
  return (
    <div
      className="flex items-center gap-1.5"
      style={{ color: ok ? "var(--color-success)" : "var(--color-text-3)" }}
    >
      <span aria-hidden="true">{ok ? "✓" : "○"}</span>
      <span>{label}</span>
    </div>
  );
}
